{/*import React, { Component } from "react"
import { observer }         from "mobx-react"
import app                  from "app.controller"
import shop                 from "shop/shop"
import WordPress            from "WordPress"
import { Button }           from "semantic-ui-react";
import cmsStore             from "../../stores/cmsStore";
import { Link }             from "react-router-dom"
import htmr                                                                           from "htmr";

@observer
export default class WordPressShopComponent extends Component {
  
  state = {
    content: false,
    current: false,
  }
  
  componentDidMount() {
    app.language.changed.add( this.load )
    this.load()
  }
  
  load = () => {
    let { slug } = this.props
    // shop.fetchFromWordPress( `acf/v3/menu?fields[name]=${slug}&lang=${app._currentLanguage}` )
    shop.fetchFromWordPressBase( `/wp-json/acf/v3/shop/?slug[]=${slug}${app.getQueryLanguageParameter()}` )
        .then( res => res[ 0 ] )
        .then( ( content ) => {
          this.setState( { content, ready: true } )
        } )
        .catch( err => {
          console.info( `WordPress Shop Component couldn't load: `, err )
        } )
  }
  
  componentWillUnmount() {
    app.language.changed.remove( this.load )
  }
  
  show = entry => {
    this.setState( { current: entry } )
  }
  
  hide = entry => {
    this.setState( { current: false } )
  }
  
  render() {
    const { isEditor, useEditor } = cmsStore
    const { children, slug, cat_id, widthOfComponent, fallback = null, ...rest } = this.props
    const FallbackElement = fallback
    const { content, ready } = this.state
    const showFallback = !content && ready
    return (
      <div {...rest} >
        {showFallback && <div>
          {FallbackElement}
        </div>}
        {console.log("content", content)}
        {(useEditor && content) && <div className={"pa4 ba bw2 b--silver b--dashed mb4 relative"}>
          {(content && widthOfComponent) && <div>{content && content.acf && content.acf.layout && content.acf.layout[0] && content.acf.layout[0].html && content.acf.layout[0].html[0] && 
          <div className=" black-40 f5">{htmr(content.acf.layout[0].html[0].html)}</div>}</div>}
        {(content && !widthOfComponent) && <WordPress page={content}/>}
          {children}
          <div className="absolute top-0 left-0 right-0 bottom-0 flex flex-row justify-center  ">
            <div className="pa3">
              <span className="dib bg-white">
                <Button style={{ marginRight: 0 }} primary as={"a"} target={"_blank"} href={`/wp/wp-admin/post.php?post=${content.id}&action=edit&lang=de&classic-editor`}>
                  <span className="b">{translate( "bearbeiten" )}</span>
                </Button>
              </span>
            </div>
          </div>
        </div>}
        
        {(useEditor && !content) && <div>
          <div className={"pa4 ba bw2 b--silver b--dashed mb4 relative flex flex-row justify-center"}>
            <Button style={{ marginRight: 0 }} primary as={"a"} target={"_blank"} href={`/wp/wp-admin/post-new.php?post_type=shop&slug=${slug}&cat_id=${cat_id}`}>
              <span className="b">Inhalt erstellen</span>
            </Button>
          </div>
        </div>}
        {(!useEditor && content && widthOfComponent) && <div>{content && content.acf && content.acf.layout && content.acf.layout[0] && content.acf.layout[0].html && content.acf.layout[0].html[0] && 
          <div className="black-40 f5">{htmr(content.acf.layout[0].html[0].html)}</div>}</div>}
        {(!useEditor && content && !widthOfComponent) && <WordPress page={content}/>}
      </div>
    )
  }
}
 */}


import React, { Component } from "react"
import { observer }         from "mobx-react"
import app                  from "app.controller"
import shop                 from "shop/shop"
import WordPress            from "WordPress"
import { Button }           from "semantic-ui-react";
import cmsStore             from "../../stores/cmsStore";
import { Link }             from "react-router-dom"

@observer
export default class WordPressShopComponent extends Component {
  
  state = {
    content: false,
    current: false,
  }
  
  componentDidMount() {
    app.language.changed.add( this.load )
    this.load()
  }
  
  load = () => {
    let { slug } = this.props
    // shop.fetchFromWordPress( `acf/v3/menu?fields[name]=${slug}&lang=${app._currentLanguage}` )
    shop.fetchFromWordPressBase( `/wp-json/acf/v3/shop/?slug[]=${slug}${app.getQueryLanguageParameter()}` )
        .then( res => res[ 0 ] )
        .then( ( content ) => {
          this.setState( { content, ready: true } )
        } )
        .catch( err => {
          console.info( `WordPress Shop Component couldn't load: `, err )
        } )
  }
  
  componentWillUnmount() {
    app.language.changed.remove( this.load )
  }
  
  show = entry => {
    this.setState( { current: entry } )
  }
  
  hide = entry => {
    this.setState( { current: false } )
  }
  
  render() {
    const { isEditor, useEditor } = cmsStore
    const { children, slug, cat_id, fallback = null, ...rest } = this.props
    const FallbackElement = fallback
    const { content, ready } = this.state
    const showFallback = !content && ready
    return (
      <div {...rest} >
        {showFallback && <div>
          {FallbackElement}
        </div>}
        
        {(useEditor && content) && <div className={"pa4 ba bw2 b--silver b--dashed mb4 relative"}>
          {content && <div className="o-40 events-none"><WordPress page={content}/></div>}
          {children}
          <div className="absolute top-0 left-0 right-0 bottom-0 flex flex-row justify-center  ">
            <div className="pa3">
              <span className="dib bg-white">
                <Button style={{ marginRight: 0 }} primary as={"a"} target={"_blank"} href={`/wp/wp-admin/post.php?post=${content.id}&action=edit&lang=de&classic-editor`}>
                  <span className="b">{translate( "bearbeiten" )}</span>
                </Button>
              </span>
            </div>
          </div>
        </div>}
        
        {(useEditor && !content) && <div>
          <div className={"pa4 ba bw2 b--silver b--dashed mb4 relative flex flex-row justify-center"}>
            <Button style={{ marginRight: 0 }} primary as={"a"} target={"_blank"} href={`/wp/wp-admin/post-new.php?post_type=shop&slug=${slug}&cat_id=${cat_id}`}>
              <span className="b">Inhalt erstellen</span>
            </Button>
          </div>
        </div>}
        {(!useEditor && content) && <WordPress page={content}/>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WordPressShopComponent/WordPressShopComponent.js